const {
  mutateValue,
  setContentValue
} = require('@truqc/content-path');
const {
  traverseFormContent
} = require('../lib/getFormContent');

// update the content of the form itself
const updateForm = async (formID, formContentPath, value, sourceEvaluator) => {
  const clearPatch = {};
  mutateValue(formContentPath, clearPatch, null);
  const setPatch = {};
  mutateValue(formContentPath, setPatch, value);
  const patchContentBehaviorSource = {
    type: 'patchContentBehavior',
    unsafePatch: true,
    id: formID,
    patches: [clearPatch, setPatch]
  };
  const result = await sourceEvaluator(patchContentBehaviorSource);
  return result;
};

// write-through live editor (if open) + shared form-content cache
const updateFormContent = async (formID, formContentPath, formContent, value, sourceEvaluator) => {
  const newFormContent = setContentValue(formContentPath, formContent, value);
  const setFormContentSource = {
    type: 'setFormContentBehavior',
    entityName: 'Form',
    uuid: formID,
    value: newFormContent
  };
  await sourceEvaluator(setFormContentSource);
};

/**
  * @function evaluate - evaluate writeReferencedContentBehavior
  */

const evaluate = async (source, content, parentContentPath, transientContext, nativeFunctions, sourceEvaluator) => {
  const {
    formID,
    formContent,
    formContentPath
  } = await traverseFormContent(source, content, parentContentPath, transientContext, nativeFunctions);
  if (formID !== undefined) {
    const value = await sourceEvaluator(source.value);
    // patchContentBehavior may return null/undefined on success — do not treat falsy as failure.
    await updateForm(formID, formContentPath, value, sourceEvaluator);
    await updateFormContent(formID, formContentPath, formContent, value, sourceEvaluator);
  }
};
module.exports = {
  evaluate
};